export const getLabels = (state: any): any => state.labels;